import React from 'react';
import LabelCanvas from '../../LabelView/LabelCanvas';

function PreviewPanel({
  visible,
  mobileView,
  labelName,
  backgroundImage,
  backgroundColor,
  borderColor,
  labelMeta,
  contentItems,
}) {
  if (!visible) return null;

  const previewLabelData = {
    labelName: labelName || '',
    backgroundImage,
    backgroundColor,
    borderColor,
    meta: labelMeta,
    contentItems: contentItems.map((item, index) => ({
      contentType: item.type,
      contentData: item.data,
      sortOrder: index + 1,
    })),
  };

  return (
    <div className={`preview-panel ${mobileView === 'preview' ? 'mobile-active' : 'mobile-hidden'}`}>
      <div className="preview-container">
        <div className="preview-header">
          <div className="preview-title">实时预览</div>
        </div>
        <div className="preview-canvas-wrapper">
          <LabelCanvas data={previewLabelData} phonePreview />
        </div>
      </div>
    </div>
  );
}

export default PreviewPanel;
